import React from 'react';
import styled from 'styled-components';

import { useWalletWithPositionsQuery } from 'api/queries/walletPositionsQueries';
import { useCopyToClipboard } from 'components/basic/icons/CopyToClipboard';
import IconClickable from 'components/basic/icons/IconClickable';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { useSelectorActiveChain } from 'components/hooks';
import CurrentWallet from 'components/wallet/CurrentWallet';
import ChainExplorerIcon from 'components/wallet/icons/explorer/ChainExplorerIcon';
import { getBlockExplorerAddressUrl } from 'config/configUtils';
import useRedirectNonMobile from 'hooks/useRedirectNonMobile';
import { formatUsdWithSign } from 'lib/display/formatting';
import { openExternalUrl } from 'lib/redirect';
import { useSelector } from 'reduxState/store';

const BalanceWrap = styled.div`
  margin: 12px 16px 0 16px;
`;

const WalletWrap = styled.div`
  margin: 0 16px;
  line-height: 1.5;
  font-size: var(--medium);
  color: var(--gray4);
`;

const WalletActionsWrap = styled.div`
  padding: 0 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 400px;
`;

const Divider = styled.div`
  background: var(--separator);
  height: 1px;
  margin: 16px 0;
`;

const Label = styled.div`
  font-size: var(--small);
  color: var(--gray4b);
  line-height: 1.5;
  white-space: nowrap;
`;

const Value = styled.div`
  font-size: var(--medium);
  color: var(--white);
  word-wrap: break-word;
  line-height: 2.5;
  overflow: hidden;
`;

const ValueLarge = styled(Value)`
  font-size: var(--medium2);
`;

function WalletMenuStatsMobile() {
  useRedirectNonMobile('/');
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const { activeChain } = useSelectorActiveChain();

  const { data: walletWithPositions } = useWalletWithPositionsQuery();

  const { onCopy, recentlyCopied } = useCopyToClipboard();

  return (
    <>
      <BalanceWrap>
        <Label>Free Collateral</Label>
        <ValueLarge>
          {walletWithPositions?.availableCollateral
            ? formatUsdWithSign(walletWithPositions.availableCollateral)
            : '-'}
        </ValueLarge>
      </BalanceWrap>
      <div style={{ height: 4 }} />
      <WalletWrap>
        <Label>Active Wallet</Label>
        <Value>
          <CurrentWallet hideTitle noPadding noBlockExplorer />
        </Value>
      </WalletWrap>
      {walletAddress && (
        <WalletActionsWrap>
          <IconClickable
            padding="8px 12px"
            icon={
              <div style={{ fontSize: 16, position: 'relative', top: 2 }}>
                <MaterialSymbol
                  icon={recentlyCopied ? 'done' : 'content_copy'}
                  fontSize="inherit"
                />
              </div>
            }
            fontSize="var(--small)"
            onClick={() => onCopy(walletAddress)}
          >
            Copy Address
          </IconClickable>
          <IconClickable
            padding="8px 12px"
            icon={<ChainExplorerIcon size="14px" />}
            fontSize="var(--small)"
            onClick={() =>
              openExternalUrl(
                getBlockExplorerAddressUrl(walletAddress, activeChain)
              )
            }
          >
            Block Explorer
          </IconClickable>
        </WalletActionsWrap>
      )}
      <Divider />
    </>
  );
}

export default WalletMenuStatsMobile;
